// @ts-nocheck
/* eslint-disable */
export const flPlusIcon = {
    data: `<svg viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.1084 21.5H35.8917" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.5 7.1084V35.8917" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'plus' as const
};